module.exports = __webpack_public_path__ + "static/img/paymentfail.c6f0ef0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/paymentfail.jpg
// module id = AC95
// module chunks = 1